<template>
  <div>
    <button class="btn btn-blue" id="id_file_input" @click="uploadPhotoClick">
      <img src="/resources/img/icons/photo.png" alt="Photo" width="35" height="36" />
      Upload photo
    </button>

    <form enctype="multipart/form-data">
      <input
        data-testid="id_image_photo_file_input"
        ref="uploadPhotoInput"
        @change="readPhoto"
        id="id_image_photo_file_input"
        type="file"
        accept="image/*, .pdf"
        class="hidden"
      />
    </form>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import PdfRenderer from "heliosx-common/dist/PdfRenderer";
import { readBlobAsDataUrl } from "heliosx-common/dist/readImage";

export default Vue.extend({
  data() {
    return {
      renderer: new PdfRenderer(),
    };
  },
  methods: {
    uploadPhotoClick() {
      if (this.$refs.uploadPhotoInput) {
        (this.$refs.uploadPhotoInput as HTMLInputElement).value = "";
        (this.$refs.uploadPhotoInput as HTMLInputElement).click();
      }
    },
    async readPhoto() {
      const imageInput = this.$refs.uploadPhotoInput as HTMLInputElement;

      if (imageInput.files && imageInput.files[0]) {
        const file = imageInput.files[0];

        if (file.type == "application/pdf") {
          this.$emit("photoRead", await this.convertPdf(file));
          return;
        }

        this.$emit("photoRead", file);
      }
    },
    async convertPdf(file: File) {
      // Firefox doesn't let their files implement Blob
      const blob = new Blob([file], {
        type: "application/pdf",
      });

      const url = await readBlobAsDataUrl(blob);
      return await this.renderer.pdfToJPEG(url);
    },
  },
});
</script>
